/* ===========================================================================
   DOMUS GIULIETTA: COMPORTAMENTOS DA FICHA DE PEÇA (Bloco D, Tarefa 16)
   Carregado com defer por blocks/dg-cta-curadoria.liquid, que leva o handle da peça
   em [data-dg-ficha]. Sem dependência. Não publica nada no Analytics: quem leva os
   eventos 'dg:*' aos pixels é assets/dg-eventos.js (Bloco F, Tarefa 30).
   1. Zoom da galeria: cada abertura dispara, em document, 'dg:galeria_zoom' com
      detail = { peca, posicao } (posicao começa em 1).
   2. Setas no zoom: com o zoom aberto, as setas esquerda e direita vão para a imagem
      anterior e a próxima (o Horizon só trata Esc).
   3. "Adquirir esta peça" leva ao carrinho: com Carrinho > Tipo = Página, o formulário
      do Horizon adiciona a peça por AJAX e fica na ficha; confirmada a adição, o
      navegador vai para a página do carrinho. Com a gaveta ligada, nada muda.
   4. Teclado na galeria do celular: abaixo de 750 px, com o contador na tela, a trilha de
      slides vira região focável (rótulo em data-dg-galeria-rotulo); as setas rolam a trilha.
   Depende do Horizon 4.1.5 (conferir depois de toda atualização):
   - snippets/product-media-gallery-content.liquid: .product-media-container__zoom-button
     (grade), slideshow-slide.product-media-container--zoomable (carrossel),
     <media-gallery>, .dialog-zoomed-gallery__dialog, .dialog-thumbnails-list__thumbnail
     com aria-selected;
   - assets/product-form.js: evento 'shopify:cart:lines-update' (action, promise,
     detail.didError);
   - snippets/scripts.liquid: Theme.routes.cart_url;
   - snippets/cart-drawer.liquid: <cart-drawer-component> só existe com a gaveta;
   - snippets/slideshow.liquid: <slideshow-slides ref="scroller" tabindex="-1"> dentro de
     slideshow-container; snippets/slideshow-controls.liquid: .slideshow-controls__counter;
     assets/slideshow.js: o contador segue a rolagem da trilha (#handleScroll).
   =========================================================================== */
(function () {
  'use strict';

  if (window.dgFichaIniciada) return;
  var raiz = document.querySelector('[data-dg-ficha]');
  if (!raiz) return;
  window.dgFichaIniciada = true;
  var peca = raiz.getAttribute('data-dg-ficha') || '';

  function posicao(item) {
    var irmaos = Array.prototype.filter.call(item.parentElement.children, function (el) {
      return el.tagName === item.tagName;
    });
    return irmaos.indexOf(item) + 1;
  }

  document.addEventListener('click', function (evento) {
    var alvo = evento.target;
    if (!(alvo instanceof Element)) return;
    var gatilho = alvo.closest(
      '.product-media-container__zoom-button, slideshow-slide.product-media-container--zoomable'
    );
    if (!gatilho || gatilho.closest('dialog') || !gatilho.closest('media-gallery')) return;
    var item = gatilho.matches('slideshow-slide') ? gatilho : gatilho.closest('li');
    if (!item || !item.parentElement) return;
    document.dispatchEvent(new CustomEvent('dg:galeria_zoom', {
      detail: { peca: peca, posicao: posicao(item) }
    }));
  }, true);

  document.addEventListener('keydown', function (evento) {
    if (evento.key !== 'ArrowLeft' && evento.key !== 'ArrowRight') return;
    var alvo = evento.target;
    if (!(alvo instanceof Element)) return;
    var dialogo = alvo.closest('.dialog-zoomed-gallery__dialog');
    if (!dialogo || !dialogo.open) return;
    var miniaturas = Array.prototype.slice.call(
      dialogo.querySelectorAll('.dialog-thumbnails-list__thumbnail')
    );
    if (miniaturas.length < 2) return;
    var atual = 0;
    miniaturas.forEach(function (botao, i) {
      if (botao.getAttribute('aria-selected') === 'true') atual = i;
    });
    var passo = evento.key === 'ArrowRight' ? 1 : -1;
    var proxima = miniaturas[(atual + passo + miniaturas.length) % miniaturas.length];
    evento.preventDefault();
    proxima.click();
    proxima.focus();
  });

  document.addEventListener('shopify:cart:lines-update', function (evento) {
    if (!evento || evento.action !== 'add' || !evento.promise) return;
    if (!(evento.target instanceof Element) || !evento.target.closest('.product-information')) return;
    if (document.querySelector('cart-drawer-component')) return;
    if (window.Shopify && window.Shopify.designMode) return;
    evento.promise.then(function (resultado) {
      if (resultado && resultado.detail && resultado.detail.didError) return;
      var destino = '/cart';
      if (typeof Theme !== 'undefined' && Theme.routes && Theme.routes.cart_url) {
        destino = Theme.routes.cart_url;
      }
      window.location.assign(destino);
    }).catch(function () {});
  });

  // 4. Teclado na galeria do celular (fechamento da Tarefa 16): abaixo de 750 px, com a
  //    paginação em Contador, nenhum controle da galeria recebia foco. A trilha de slides
  //    (<slideshow-slides ref="scroller">, tabindex="-1" no Horizon) vira região focável com o
  //    rótulo de dg.ficha.galeria_rotulo (data-dg-galeria-rotulo); as setas rolam a trilha e o
  //    Horizon atualiza o contador pela rolagem. A partir de 750 px (grade, botões de zoom
  //    focáveis), a trilha volta a tabindex="-1", sem papel nem rótulo.
  var rotuloGaleria = raiz.getAttribute('data-dg-galeria-rotulo') || '';
  var trilha = document.querySelector(
    '.product-information__media media-gallery > slideshow-component > slideshow-container > slideshow-slides'
  );
  var contadores = document.querySelectorAll(
    '.product-information__media media-gallery > slideshow-component slideshow-controls .slideshow-controls__counter'
  );
  if (rotuloGaleria && trilha && contadores.length && window.matchMedia) {
    var celular = window.matchMedia('(max-width: 749px)');
    var contadorNaTela = function () {
      return Array.prototype.some.call(contadores, function (c) { return c.getClientRects().length > 0; });
    };
    var ajustarTrilha = function () {
      if (celular.matches && contadorNaTela()) {
        trilha.setAttribute('tabindex', '0');
        trilha.setAttribute('role', 'region');
        trilha.setAttribute('aria-label', rotuloGaleria);
      } else {
        trilha.setAttribute('tabindex', '-1');
        trilha.removeAttribute('role');
        trilha.removeAttribute('aria-label');
      }
    };
    ajustarTrilha();
    if (celular.addEventListener) celular.addEventListener('change', ajustarTrilha);
  }
})();
